import api from './api';

export const applicationService = {
  submitApplication: (formData) => api.post('/applications', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  getAll: (status) => api.get('/applications', { params: { status } }),
  getStats: () => api.get('/applications/stats'),
  getById: (id) => api.get(`/applications/${id}`),
  updateStatus: (id, status) => api.patch(`/applications/${id}/status`, { status }),
  delete: (id) => api.delete(`/applications/${id}`),
  // Route yêu cầu Bearer token nên không thể tải bằng thẻ <a href> thường —
  // fetch blob qua axios (đã tự gắn token) rồi kích hoạt tải về phía client.
  downloadCv: async (id, filename) => {
    const blob = await api.get(`/applications/${id}/download-cv`, { responseType: 'blob' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || 'CV';
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }
};
